// extracted by mini-css-extract-plugin
module.exports = {"TabContainer":"AccountOrganisation_TabContainer__3VJUo"};